import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BusinessIntro = lazy(() => import('../pages/business/intro/page'));
const LocationEnvironment = lazy(() => import('../pages/location/environment/page'));
const LocationPremium = lazy(() => import('../pages/location/premium/page'));
const ComplexLayout = lazy(() => import('../pages/complex/layout/page'));
const ComplexBuilding = lazy(() => import('../pages/complex/building/page'));
const ComplexCommunity = lazy(() => import('../pages/complex/community/page'));
const FloorPlanTypes = lazy(() => import('../pages/floor-plan/types/page'));
const Reservation = lazy(() => import('../pages/reservation/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/business/intro',
    element: <BusinessIntro />,
  },
  {
    path: '/location/environment',
    element: <LocationEnvironment />,
  },
  {
    path: '/location/premium',
    element: <LocationPremium />,
  },
  {
    path: '/complex/layout',
    element: <ComplexLayout />,
  },
  {
    path: '/complex/building',
    element: <ComplexBuilding />,
  },
  {
    path: '/complex/community',
    element: <ComplexCommunity />,
  },
  {
    path: '/floor-plan/types',
    element: <FloorPlanTypes />,
  },
  {
    path: '/reservation',
    element: <Reservation />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
